import { render, staticRenderFns } from "./WineProductSvgIcons.vue?vue&type=template&id=5af7d6bf&scoped=true"
import script from "./WineProductSvgIcons.vue?vue&type=script&lang=js"
export * from "./WineProductSvgIcons.vue?vue&type=script&lang=js"
import style0 from "./WineProductSvgIcons.vue?vue&type=style&index=0&id=5af7d6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7d6bf",
  null
  
)

export default component.exports